<template>
<div id="Navbar">
    <b-navbar type="light" variant="light" toggleable="md">
        <b-navbar-brand>
            <router-link to="/app">
                <img :src="imglogo" style="width:60px">
            </router-link>
        </b-navbar-brand>
        <b-nav-toggle target="nav_dropdown_collapse"></b-nav-toggle>
        <b-collapse is-nav id="nav_dropdown_collapse">
            <b-navbar-nav>
                <b-nav-item>
                    <router-link id="nav-home" to="/app">Home</router-link>
                </b-nav-item>
                <!-- Navbar dropdowns -->
                <b-nav-item-dropdown text="Opzioni" right>
                    <b-dropdown-item v-if="ctrlVismenu('T')">
                        <router-link to="/app/categorie">Categorie</router-link>
                    </b-dropdown-item>
<!--                     <b-dropdown-item v-if="ctrlVismenu('C')">
                        <router-link to="/app/convenzioni">Convenzioni</router-link>
                    </b-dropdown-item> -->
                    <b-dropdown-item v-if="ctrlVismenu('E')">
                        <router-link to="/app/eventi">Eventi</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('S') || ctrlVismenu('Z')">
                        <router-link to="/app/soci">Soci</router-link>
                    </b-dropdown-item>
<!--                     <b-dropdown-item v-if="ctrlVismenu('P')">
                        <router-link to="/app/pagamenti">Pagamenti</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('O')">
                        <router-link to="/app/sconti">Sconti</router-link>
                    </b-dropdown-item>  -->
                    <b-dropdown-item v-if="ctrlVismenu('D')">
                        <router-link to="/app/documenti">Documenti</router-link>
                    </b-dropdown-item>
<!--                     <b-dropdown-item v-if="ctrlVismenu('I')">
                        <router-link to="/app/impianti">Impianti</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('A')">
                        <router-link to="/app/abbonamenti">Abbonamenti</router-link>
                    </b-dropdown-item>  -->
                    <b-dropdown-item v-if="ctrlVismenu('Q')">
                        <router-link to="/app/questionari">Questionari</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('U')">
                        <router-link to="/app/push">Push Notification</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('N')">
                        <router-link to="/app/news">News</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('B')">
                        <router-link to="/app/bacheca">Bancarella</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item v-if="ctrlVismenu('L')">
                        <router-link to="/app/modulistica">Modulistica</router-link>
                    </b-dropdown-item>
<!--                     <b-dropdown-item v-if="ctrlVismenu('R')">
                        <router-link to="/app/prenotazioni">Prenotazioni</router-link>
                    </b-dropdown-item> -->
                    <b-dropdown-item v-if="ctrlVismenu('M')">
                        <router-link to="/app/parametri">Parametri</router-link>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <!-- Using button-content slot -->
                    <template slot="button-content">
                        <em>{{ user }}</em>
                    </template>
                    <b-dropdown-item>
                        <router-link v-if="ctrlVismenu('S') || ctrlVismenu('Z')" :to="urlsocio">Profilo</router-link>
                    </b-dropdown-item>
                    <b-dropdown-item>
                        <router-link to="/app/logout">Logout</router-link>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</div>
</template>

<script>

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'Navbar',
    methods: {
        ctrlVismenu(key){
            //sembra ricorsiva ma non lo è, qui sotto viene chiamata la funzione di util.js
            return ctrlVismenu(key);
        }
    },
    data: function () {

        var nome = localStorage.getItem('nome') || '';
        var cognome = localStorage.getItem('cognome') || '';
        var idsocio = localStorage.getItem('idsocio');

        return {
            user: nome + ' ' + cognome,
            idsocio: idsocio,
            urlsocio: '/app/dettagliosocio/' + idsocio,
            imglogo: require('../assets/logoappcral.png')
        };

    },
    //ATTENZIONE: non funziona lo stesso andrebbe usato vuex per lo storage per averlo reattivo o qualche libreria
    // computed: {
    //     user: {
    //         // getter
    //         get: function () {
    //             var nome = localStorage.getItem('nome') || '';
    //             var cognome = localStorage.getItem('cognome') || '';
    //             return nome + ' ' + cognome;
    //         },
    //         // setter
    //         set: function (newValue) {

    //         }
    //     },

    // }
}
</script>

<style scoped>
#nav-home {
    color: rgba(0, 0, 0, .5);
    text-decoration: none;
}

#nav-home:hover,
#nav-home:active {
    color: #4A4A4B;
}
</style>
